import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './onpage-country-selector.component.scss';
import * as $ from 'jquery';
var OnpageCountrySelector = /** @class */ (function (_super) {
    tslib_1.__extends(OnpageCountrySelector, _super);
    function OnpageCountrySelector(element) {
        return _super.call(this, element) || this;
    }
    OnpageCountrySelector.prototype.init = function () {
        var _this = this;
        this.button = this.element.querySelector('.onpage-country-selector__button');
        this.modalContainer = this.element.querySelector('.onpage-country-selector__modal');
        if (this.element.querySelector('.onpage-country-selector__countries')) {
            this.countrySelector = this.element.querySelector('.onpage-country-selector__countries');
        }
        if (this.element.querySelector('.onpage-country-selector__countries__close')) {
            this.countrySelectorCloseButton = this.element.querySelector('.onpage-country-selector__countries__close');
        }
        this.countries = [];
        $('.onpage-country-selector__countries__section-country').each(function (index, el) {
            _this.countries.push({
                country: $(el).data('country'),
                section: $(el).data('section'),
                element: $(el)
            });
        });
    };
    OnpageCountrySelector.prototype.bindEvents = function () {
        var _this = this;
        this.button.addEventListener('click', function (e) {
            _this.modalContainer.classList.add('onpage-country-selector__modal--active');
            if (_this.countrySelector) {
                _this.countrySelector.classList.add('onpage-country-selector__countries__modal--reveal');
            }
        });
        if (this.countrySelectorCloseButton) {
            this.countrySelectorCloseButton.addEventListener('click', function (e) {
                _this.modalContainer.classList.remove('onpage-country-selector__modal--active');
            });
        }
        $('.onpage-country-selector__countries__close').click(function () {
            $('.onpage-country-selector__countries__modal').addClass('country-selector__modal--disappear');
            setTimeout(function () {
                $('.onpage-country-selector__countries__modal')
                    .removeClass('onpage-country-selector__countries__modal--reveal')
                    .removeClass('onpage-country-selector__countries__modal--disappear');
            }, 400);
        });
        $('.onpage-country-selector__countries__search-input').keyup(function () {
            var searchParam = $('.onpage-country-selector__countries__search-input').val().toLowerCase();
            if (searchParam.length > 0) {
                $('.onpage-country-selector__countries__section').hide();
                $('.onpage-country-selector__countries__section-country').hide();
                _this.countries.filter(function (item, index) {
                    return item.country.toLowerCase().indexOf(searchParam) > -1;
                }).forEach(function (country) {
                    country.element.show();
                    $(".onpage-country-selector__countries__section[data-section='" + country.section + "']").show();
                });
            }
            else {
                _this.countries.forEach(function (country) {
                    country.element.show();
                    $(".onpage-country-selector__countries__section").show();
                });
            }
        });
    };
    return OnpageCountrySelector;
}(Base));
export { OnpageCountrySelector };



//////////////////
// WEBPACK FOOTER
// ./components/onpage-country-selector/onpage-country-selector.component.ts
// module id = 417
// module chunks = 0